import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthRoute } from '@portal-core/auth/enums/auth-route.enum';
import { ApiService } from '@portal-core/auth/services/api.service';
import { AuthRouteService } from '@portal-core/auth/services/auth-route.service';
import { AuthUrlService } from '@portal-core/auth/services/auth-url.service';
import { AuthService } from '@portal-core/auth/services/auth.service';
import { Observable, catchError, map, of, switchMap, tap } from 'rxjs';

export const centralInstanceSubdomainGuard: CanActivateFn = (): Observable<boolean> => {
  const authService = inject(AuthService);
  const authRouteService = inject(AuthRouteService);
  const authUrlService = inject(AuthUrlService);
  const apiService = inject(ApiService);

  // Route guards can be called multiple times as navigation occurs. Check if the subdomain has already been validated before doing the work to validate it.
  if (authService.hasValidatedSubdomain()) {
    return of(authService.isValidSubdomain());
  }

  return authService.getLicenseCentralInstance$(authUrlService.getSubdomain()).pipe(
    tap(centralInstance => {
      apiService.setCentralInstance(centralInstance);
    }),
    switchMap(() => authService.getSubdomainLicense$()),
    map(license => {
      if (license) {
        return true;
      } else {
        authRouteService.navigateToAuthRoute$(AuthRoute.SubdomainGuardError).subscribe();
        return false;
      }
    }),
    catchError(() => {
      authRouteService.navigateToAuthRoute$(AuthRoute.SubdomainGuardError).subscribe();
      return of(false);
    })
  );
};
